/* eslint-disable */
import { loadGmap } from '../../../../general/js/loadGmap';

var map;
var defaultZoom = 12;
var geocoder;
var mapCenter;
var minZoomLevel = 5;
var pinList = [];
var singleItemZoom = 15;
var currentLocation = "";
var currentAddress = "";
var encodedAddress = "";

// Define Marker properties
var pin;
let address;


$(function () {

  var eventLocation = $('#event-location').val();

  if (eventLocation != undefined && eventLocation != "") {
      address = eventLocation;
      showMap();

      encodedAddress = encodeURIComponent(eventLocation);
      $('.map-directions-link a').attr('href', '//www.google.com/maps/dir//' + encodedAddress);
      $('.map-directions-link').show();
  }
  else
  {
    $('#map-canvas-event').hide();
  }
});

// Initialize the Google map
window.initializeEventMap = function() {

    mapCenter = new google.maps.LatLng(53.367692, -1.574135);

    pin = new google.maps.MarkerImage('/dist/images/map-pin.png',
        // This marker is 60 pixels wide by 80 pixels tall.
        new google.maps.Size(60, 80),
        // The origin for this image is 0,0.
        new google.maps.Point(0, 0),
        // The anchor for this image is the center of the image baseline.
        new google.maps.Point(0, 30)
    );

  geocoder = new google.maps.Geocoder();
  var mapOptions = {
    zoom: defaultZoom,
    center: mapCenter,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    streetViewControl: false,
    disableDefaultUI: false,
    disableDoubleClickZoom: true,
    scrollwheel: false,
    draggable: true
  }

  map = new google.maps.Map(document.getElementById("map-canvas-event"), mapOptions);

  // Limit the zoom level
  google.maps.event.addListener(map, 'zoom_changed', function () {
    if (map.getZoom() < minZoomLevel) map.setZoom(minZoomLevel);
  });

  google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
    if (map.getZoom() > singleItemZoom) map.setZoom(singleItemZoom);
  });

  let infowindow = new google.maps.InfoWindow({
    content: "..."
  });

  google.maps.event.addDomListener(window, 'resize', function () {
    map.setCenter(mapCenter);
  });

    if (address != "") {
        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {

                mapCenter = results[0].geometry.location;
                map.setCenter(mapCenter);

                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location,
                    icon: pin
                });
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}


function showMap() {
      if (typeof google === 'object' && typeof google.maps === 'object') {
          initializeEventMap();
      } else {
          loadGmap('initializeEventMap');
      }
}
